import { gql } from "@apollo/client";

const AddUserDeviceMutation = gql`
  mutation addUserDeviceMutation($userId: UUID!, $id: BigInt!) {
    createUserDevice(
      input: { userDevice: { userAppId: $userId, deviceId: $id } }
    ) {
      userDevice {
        id
        deviceId
      }
    }
  }
`;

const hash = "ab5b85e4085bd649c0a4f3f60b162a87bfdda142d33f111c85e0d68746d30d92";

export { AddUserDeviceMutation, hash };
